import { AnimateTyping } from "component/AnimateTyping";
import Text from "component/Text";
import { useAppSelector } from "hook/redux";
import useIsWhitelabelled from "hook/useIsWhitelabelled";
import { ConfigCatFeatureFlag } from "util/CommonConstant";

interface AuthPageWelcomeHeaderProps {
  children?: React.ReactNode;
}

export function AuthPageWelcomeHeader({ children }: AuthPageWelcomeHeaderProps) {
  const { logoUrl, tagLine, productName, authLogoHeight } = useIsWhitelabelled();

  return (
    <div className="mt-0 w-full xs:mt-9 sm:w-3/5 lg:mt-0 lg:w-129">
      <div className="mb-5 animate-slideRight">
        {/* current img width is for default logo */}
        <img src={logoUrl} alt="logo" style={{ height: authLogoHeight + "px" }} />
      </div>
      <h1 className="mb-2 text-3xl xs:mb-6 xs:text-4xl md:text-heading-1">
        {tagLine ? (
          <>
            {tagLine.split("\n").map((line, idx) => (
              <span key={idx}>
                {line}
                {idx !== tagLine.split("\n").length - 1 && <br />}
              </span>
            ))}
            {/* <br /> */}
            {/* <span className="flex gap-3.252 lg:w-129">
              <Text label="label.text.login.poweredby" /> <AnimateTyping>Hawkeye!</AnimateTyping>
            </span> */}
          </>
        ) : (
          <>
            <Text label={"label.text.login.welcomeNote"} />
            <br />
            <Text label={"label.text.login.welcomeNote.with"} />{" "}
            <AnimateTyping>{productName}!</AnimateTyping>
          </>
        )}
      </h1>
      {children}
    </div>
  );
}
